import { render, staticRenderFns } from "./SubscriptionView.vue?vue&type=template&id=36f8ece6"
import script from "./SubscriptionView.vue?vue&type=script&lang=js"
export * from "./SubscriptionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports